'use strict';




document.ready = new Promise((resolve) => document.addEventListener('DOMContentLoaded', resolve));

document.ready.then(() => {

  const checkOutForm = document.querySelector('#submitBasketToOrder');

  if (checkOutForm) {


    document.globals.order.deliveryPrice = new _DeliveryPrice();

    checkOutForm.addEventListener('click', (e) => {
      const target = e.target;

      if (target.nodeName == 'INPUT') {
        if (target.name == 'data[delivery]') {

          //clear and hide delivery price
          document.globals.order.deliveryPrice.value = '';

          let isChecked = target.checked;


          if (target.id == 'item_delivery_35565') {//sales delivery
            if (isChecked) {
              document.globals.order.deliveryPrice.value = 'В зависимости от <a target="_blank" style="text-decoration:underline" href="https://yandex.ru/maps/2/saint-petersburg/?from=mapframe&ll=30.378735%2C59.961083&mode=usermaps&source=mapframe&um=constructor%3A08589fc08ccba7d616e1fee5458cebd86c581952b9c34b86242d6703a0f4ab4b&utm_source=mapframe&z=9">зоны доставки</a>';
            } else {
              document.globals.order.deliveryPrice.value = '';
            }
          }

          if (target.id == 'item_delivery_35564') { //CDEK
                      
          }

        }
      }

    })
  }

  

});



window.orderWidjet = new window.ISDEKWidjet({
        popup: true,
        cityFrom: 'Санкт-Петербург',
    detailAddress: true,
    hidedress: true,
    path: 'https://amix-tk.ru/sdekwidget/scripts/', 
        servicepath: 'https://amix-tk.ru/sdekwidget/scripts/service.php', 
        apikey: '658a5c26-3cff-4780-ab07-07c703e76883',
    //goods:  JSON.parse(localStorage.getItem("gabarity")),
    goods:  [],
    country: 'Россия',
        defaultCity: 'Санкт-Петербург',
        lang: 'rus',
        onReady : function(){ // на загрузку виджета отобразим информацию о доставке до ПВЗ
            ipjq('#linkForWidjet').css('display','inline');
      $("#choosed-pvz").hide();
      $("#choosed-to-door").hide();
        },
        onChoose : function(info){ // при выборе ПВЗ: запишем номер ПВЗ в текстовое поле и доп. информацию
      $("#choosed-to-door").hide();
            ipjq('[name="data[chosenPost]"]').val(info.id);
            ipjq('[name="data[addresPVZ]"]').val(info.cityName + ', ' + info.PVZ.Address);
      ipjq('[name="addresPVZ"]').val(info.cityName + ', ' + info.PVZ.Address);
            // расчет стоимости доставки
            let price = (info.price < 300) ? 300 : Math.ceil( info.price/50 ) * 50;
            ipjq('[name="data[pricePost]"]').val(price);
      ipjq('[name="pricePost"]').val(price);
            ipjq('[name="data[timePost]"]').val(info.term);
      ipjq('[name="timePost"]').val(info.term);
      $('#sdek-to-door').prop('checked', false);
      ipjq('[name="data[to-door]"]').val(0);
      ipjq('[name="data[gorod_dostavki]"]').val(info.cityName);
      $.ajax({
          url: "/emarket/userCountryFromSDEK/"+info.city+"/",
          success: function(data){
          $('#strana-dostavki').val(data);
        }
      });  
      $("#choosed-pvz").show();
            window.orderWidjet.close(); // закроем виджет

            document.globals.order.deliveryPrice.value = price + ' руб';
        },
    onChooseProfile: function(info){ // при выборе курьерской доставки запишем стоимость и сроки в текстовые поля
      $("#choosed-pvz").hide();
      console.log(info);
      ipjq('[name="data[chosenPost]"]').val('');
            ipjq('[name="data[addresPVZ]"]').val('');
            let price = (info.price < 300) ? 300 : Math.ceil( info.price/50 ) * 50;
            ipjq('[name="pricePost"]').val(price);
      ipjq('[name="data[pricePost]"]').val(price);
            ipjq('[name="timePost"]').val(info.term);
      ipjq('[name="data[timePost]"]').val(info.term);
      $('#sdek-to-door').prop('checked', true);
      ipjq('[name="data[to-door]"]').val(1);
      ipjq('[name="data[gorod_dostavki]"]').val(info.cityName);
      $.ajax({
          url: "/emarket/userCountryFromSDEK/"+info.city+"/",
          success: function(data){
          
          $('#strana-dostavki').val(data);
        }
      });  
      $("#choosed-to-door").show();
            window.orderWidjet.close(); // закроем виджет

            document.globals.order.deliveryPrice.value = price + ' руб';
    },
    onCalculate: function(info){
    //alert ('курьер '+info.profiles.courier.price);
    //alert ('пункт выдачи '+info.profiles.pickup.price);
      let totalprice = 9902.59;
      let strahovka = totalprice*0.0075;
      let itogpriceCourier = info.profiles.courier.price*1 + 5 + strahovka;
      let itogpricePvz = info.profiles.pickup.price*1 + 5 + strahovka;
            info.profiles.courier.price = Math.ceil(itogpriceCourier/50)*50;
      info.profiles.pickup.price = Math.ceil(itogpricePvz/50)*50;
      
      info.profiles.courier.price = (Math.ceil(itogpriceCourier/50)*50 < 300) ? 300 : Math.ceil(itogpriceCourier/50)*50;
      info.profiles.pickup.price = (Math.ceil(itogpricePvz/50)*50 < 300) ? 300 : Math.ceil(itogpricePvz/50)*50;
        }
    });


//window.orderWidjet = orderWidjet;
document.globals.orderWidjet = orderWidjet;
document.globals.test = '444';


//add to from CART.JS 104


class _DeliveryPrice {
  constructor() {
    this.priceContainer = document.querySelectorAll('.js-checkout-delivery-wrapper');
    this.priceValue = document.querySelectorAll('.js-checkout-delivery-value');
  }

  set value(value) {
    this.priceValue.forEach((item) => {
      //item.textContent = value;
      item.innerHTML = value;
    });

    this.priceContainer.forEach((item) => {
      if (value) {
        item.style.display = 'block';
      } else {
        item.style.display = 'none';
      }
    });
    

    
  }
}



